<template>
  <div class="box-voice">
    <div class="voice-header m-b-10">
      <div>
        <v-icon>fa-dollar-sign</v-icon>
        <span class="m-l-5">Variable</span>
      </div>
      <div>
        <v-icon small class="m-l-5" @click="deletePrompt">
          fa-times-circle
        </v-icon>
      </div>
    </div>
    <div class="d-flex">
      <v-text-field
        class="min-width-55 top-5 no-drag p-b-0"
        v-model="prompt.name"
        placeholder="Variable"
        hint="For example, ${api.data.*}"
        dense
        @keyup.down="pressDown"
        @keyup.up="pressUp"
        @keydown.enter="onEnter"
        @keydown.tab="pressTab"
      >
      </v-text-field>
      <v-select
        class="m-l-10 top-5 no-drag"
        v-model="prompt.say_as"
        :items="categories"
        item-text="text"
        item-value="value"
        placeholder="Say as"
        @change="changeSayAs"
        dense
        hide-details
      >
        <template v-slot:selection="{ attrs, item }">
          <div v-if="item.tooltip">
            <v-tooltip top :open-delay="700">
              <template v-slot:activator="{ on, attrs }">
                <div v-bind="attrs" v-on="on">{{ item.text }}</div>
              </template>
              <div v-html="item.tooltip"></div>
            </v-tooltip>
          </div>
          <div v-else>{{ item.text }}</div>
        </template>
        <template v-slot:item="{ item }">
          <div class="v-list-item__content">
            <div class="v-list-item__title">
              <div v-if="item.tooltip">
                <v-tooltip top :open-delay="700">
                  <template v-slot:activator="{ on, attrs }">
                    <div v-bind="attrs" v-on="on">{{ item.text }}</div>
                  </template>
                  <div v-html="item.tooltip"></div>
                </v-tooltip>
              </div>
              <div v-else>{{ item.text }}</div>
            </div>
          </div>
        </template>
      </v-select>
    </div>
    <div
      v-if="
        [
          'DATE_LONG_BE',
          'DATE_MEDIUM_BE',
          'DATE_SHORT',
          'DATE_CASUAL_BE'
        ].includes(prompt.say_as)
      "
      class="d-flex m-t-10"
    >
      <v-text-field
        class="min-width-55 top-5 no-drag"
        v-model="prompt.format"
        placeholder="Source date format"
        dense
        hide-details
      >
      </v-text-field>
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-icon small v-bind="attrs" v-on="on" class="m-l-10">
            fa-info-circle
          </v-icon>
        </template>
        <div>
          Specify date format to match source data e.g.
          <div v-html="formats.join('<br>')"></div>
        </div>
      </v-tooltip>
    </div>
    <!-- === use for Intellisense ===-->
    <intellisense-component
      :input="prompt.name"
      :drawFlowItems="drawFlowItems"
      :apiForIntellisense="apiForIntellisense"
      :start="start"
      :eventKey="eventKey"
      @clearSelected="clearSelected"
      @updateInputFromIntellisense="updateInputFromIntellisense"
    />
    <!-- === use for Intellisense ===-->
  </div>
</template>

<script>
// === use for Intellisense ===
import IntellisenseComponent from '../../../../components/intellisense'
// === use for Intellisense ===
export default {
  name: 'PayloadParameter',
  props: {
    index: Number,
    prompt: Object,
    categories: Array,
    // === use for Intellisense ===
    drawFlowItems: Object,
    apiForIntellisense: Object
    // === use for Intellisense ===
  },
  data() {
    return {
      formats: ['dd-MM-yyyy', 'd-M-yyyy', 'dd/MM/yyyy', 'd/M/yyyy'],
      // === use for Intellisense ===
      start: -1,
      isKeyTab: false,
      eventKey: ''
      // === use for Intellisense ===
    }
  },
  // === use for Intellisense ===
  components: {
    IntellisenseComponent
  },
  // === use for Intellisense ===
  methods: {
    changeSayAs() {
      if (
        [
          'DATE_LONG_BE',
          'DATE_MEDIUM_BE',
          'DATE_SHORT',
          'DATE_CASUAL_BE'
        ].includes(this.prompt.say_as)
      )
        this.prompt.format = this.prompt.format || 'dd-MM-yyyy'
    },
    deletePrompt() {
      this.$emit('deletePrompt', this.index)
    },
    // === use for Intellisense ให้ keyup keyDown ได้ ===

    pressDown() {
      this.start += 1
      this.eventKey = 'keydown'
    },
    pressUp() {
      this.start -= 1
      this.eventKey = 'keyup'
    },
    pressTab() {
      this.isKeyTab = true
      this.start = -1
    },
    onEnter() {
      this.start = -1
      this.eventKey = 'enter'
    },
    clearSelected() {
      this.start = -1
    },
    updateInputFromIntellisense(property, data) {
      this.prompt.name = data
    }
    // === use for Intellisense ให้ keyup keyDown ได้ ===
  }
}
</script>

<style scoped lang="scss">
::v-deep .v-messages__message {
  font-size: 10px;
}

.min-width-55 {
  min-width: 55%;
}

.box-voice {
  background-color: #f7f7f7;
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #ebebeb;
}

.voice-header {
  display: flex;
  justify-content: space-between;
}

.top-5 {
  margin-top: 4px;
  padding: 6px 10px 10px 10px;
  background: white;
}
</style>
